import { useTranslation } from 'react-i18next';
import CommonLayout from './common-layout';
import { useAppSelector } from 'hooks/useAppDispatchSelector';

const SurveyFeedbackDetails = () => {
  const { selectedSurveyFeedback } = useAppSelector(state => state.surveys);
  const { t } = useTranslation();
  const getRattingUI = (rate: number) => {
    const starUI = [];
    for (let i = 1; i <= 10; i++) {
      starUI.push(
        <div
          className={`flex items-center justify-center rounded-full border-primary border-1 h-6 w-6 ${
            i <= rate ? 'bg-primary' : 'bg-white'
          }`}
        >
          <label className={`text-xs font-semibold ${i <= rate ? 'text-white' : 'text-black'}`}>
            {i}
          </label>
        </div>,
      );
    }
    return <div className="flex items-center justify-end flex-1 gap-x-1 ml-3">{starUI}</div>;
  };
  return (
    <CommonLayout
      onConfirm={() => {}}
      confirmButtonProps={{ label: '', hide: true }}
      cancelButtonProps={{ label: 'Close' }}
    >
      <div className="flex flex-wrap w-full py-6 px-8 gap-y-2">
        {selectedSurveyFeedback?.question_answer.map((data, index) => (
          <div className="flex flex-wrap items-center p-3 border-2 rounded-4 w-full gap-y-1">
            <div className="flex w-full items-center">
              <label className="text-base font-semibold w-2/3">{`${index + 1}. ${
                data?.question || ''
              }`}</label>
              {getRattingUI(data?.rating)}
            </div>
            {data?.remark ? (
              <div className="flex items-center flex-wrap w-full pl-6">
                <label className="font-medium text-sm">
                  {t('satisfactionSurvey.surveyDetails.remark')}:
                </label>
                <p className="text-sm w-full  text-secondaryLight ">{data?.remark}</p>
              </div>
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
    </CommonLayout>
  );
};

export default SurveyFeedbackDetails;
